import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signIn } from "../../Controllers/authController";
import { useAuthStatus } from "../../Controllers/authController";
import ErrorDialog from "../DialogHandling/ErrorDialog"; // Import ErrorDialog component
import LoadingPage from "../Loading/Loading";
import { useUser } from "../AdminDashBoard/UserContext";
import { loginSuccess } from "../../redux/authActions";
import { useDispatch,useSelector } from "react-redux"; // Import useDispatch from react-redux
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const { isLoggedIn, checked } = useAuthStatus();
  const navigate = useNavigate();

  const dispatch = useDispatch(); // Initialize useDispatch
  const { updateAdmin} = useUser();

  // Redirect if already logged in
  if (isLoggedIn && checked) {
    navigate("/admin-dashboard");
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    const result = await signIn(email, password);

    if (result.error) {
      setError(result.error);
      setShowErrorDialog(true); // Show the error dialog when there is an error
    } else {
      dispatch(loginSuccess(result.userData));
      navigate("/admin-dashboard"); // Redirect to Admin Dashboard on success
    }
  };

  // Render a loading screen or null while checking auth status
  if (!checked) {
    return <LoadingPage/>; // Customize as needed
  }

  const handleCloseErrorDialog = () => {
    setShowErrorDialog(false);
  };

  return (
    <section className="bg-gradient-to-r from-[#0AD1C8] to-[#073235] min-h-screen flex box-border justify-center items-center">
      <div className="bg-[#80ED99] rounded-2xl flex max-w-3xl p-5 items-center">
        <div className="md:w-1/2 px-8">
          <h2 className="font-bold text-center text-3xl text-[#002D74]">Admin Login</h2>
          <p className="text-sm mt-4 text-center text-[#002D74]">
            If you are already a member, easily log in now.
          </p>
          <form onSubmit={handleLogin} className="flex flex-col gap-4">
            <input
              className="p-2 mt-8 rounded-xl border"
              type="email"
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              className="p-2 rounded-xl border"
              type="password"
              name="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              className="bg-[#002D74] text-white py-2 rounded-xl hover:scale-105 duration-300 hover:bg-[#206ab1] font-medium"
              type="submit"
            >
              Login
            </button>
          </form>
          {showErrorDialog && (
            <ErrorDialog
              message={error}
              onClose={handleCloseErrorDialog}
              isOpen={showErrorDialog}
            />
          )}
        </div>
        <div className="md:block hidden w-1/2">
          <img
            className="rounded-2xl max-h-[300px]" // Corrected the max-height
            src="https://cdn.pixabay.com/photo/2024/04/01/14/43/ai-generated-8669101_640.png"
            alt="login form visual"
          />
        </div>
      </div>
    </section>
  );
};

export default Login;
